import { render, staticRenderFns } from "./gsTd.vue?vue&type=template&id=79eba06c&scoped=true&"
import script from "./gsTd.vue?vue&type=script&lang=js&"
export * from "./gsTd.vue?vue&type=script&lang=js&"
import style0 from "./gsTd.vue?vue&type=style&index=0&id=79eba06c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eba06c",
  null
  
)

export default component.exports